(function () {
  if (window.__oyxCartFlowLoaded) return;
  window.__oyxCartFlowLoaded = true;

  // A disabled variant input is omitted by FormData. Supply it only for
  // ordinary product forms; leave Shrine's generated bundle items intact.
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;

    var data = event.formData;
    var hasItems = false;
    data.forEach(function (value, key) {
      if (/^items\[\d+\]\[id\]$/.test(key) && value) hasItems = true;
    });
    if (data.get('id') || hasItems) return;

    var variant = form.querySelector('input.product-variant-id[name="id"]');
    if (variant && /^\d+$/.test(variant.value)) data.set('id', variant.value);
  }, true);

  function cartAddUrl() {
    return window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
  }

  function checkoutUrl() {
    return '/checkout';
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function cartUpdateUrl() {
    return window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update';
  }

  function getCartTrigger(target) {
    if (!(target instanceof Element)) return null;

    return target.closest(
      '#cart-icon-bubble, .header__icon--cart, a[aria-label="Cart"][href*="/cart"], a[class*="sticky-header-cart"][href*="/cart"]'
    );
  }

  function forceOpenCartDrawer(drawer) {
    if (!drawer) return false;

    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function openCartDrawer(trigger) {
    var drawer = getCartDrawer();
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open(trigger || document.getElementById('cart-icon-bubble'));
      window.setTimeout(function () {
        if (!drawer.classList.contains('active')) forceOpenCartDrawer(drawer);
      }, 80);
      return true;
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () {
        var readyDrawer = getCartDrawer();
        if (readyDrawer && typeof readyDrawer.open === 'function') {
          readyDrawer.open(trigger || document.getElementById('cart-icon-bubble'));
          window.setTimeout(function () {
            if (!readyDrawer.classList.contains('active')) forceOpenCartDrawer(readyDrawer);
          }, 80);
        } else {
          forceOpenCartDrawer(readyDrawer);
        }
      });
    }

    return false;
  }

  function isCartAddRequest(input) {
    var rawUrl = '';

    if (typeof input === 'string') {
      rawUrl = input;
    } else if (input && input.url) {
      rawUrl = input.url;
    }

    return rawUrl.indexOf('/cart/add') !== -1 || rawUrl.indexOf(cartAddUrl()) !== -1;
  }

  function isCartChangeRequest(input) {
    var rawUrl = '';

    if (typeof input === 'string') {
      rawUrl = input;
    } else if (input && input.url) {
      rawUrl = input.url;
    }

    return rawUrl.indexOf('/cart/change') !== -1
      || (window.routes && window.routes.cart_change_url && rawUrl.indexOf(window.routes.cart_change_url) !== -1);
  }

  function getCartDrawerSectionIds(drawer) {
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender()
      : [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];

    return sections.map(function (section) {
      return section && section.id;
    }).filter(Boolean);
  }

  function getAddedItemId(data) {
    if (!data) return undefined;
    if (data.id) return data.id;
    if (data.items && data.items[0] && data.items[0].id) return data.items[0].id;

    return undefined;
  }

  function renderCartDrawerState(cartState, shouldOpen) {
    var drawer = getCartDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function' || !cartState || !cartState.sections) {
      return false;
    }

    drawer.renderContents(cartState, !shouldOpen);

    if (shouldOpen && !drawer.classList.contains('active')) {
      openCartDrawer();
    }

    return true;
  }

  function refreshCartDrawer(data) {
    var drawer = getCartDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) {
      return Promise.resolve(false);
    }

    var sectionIds = getCartDrawerSectionIds(drawer);
    if (!sectionIds.length) return Promise.resolve(false);

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not refresh cart drawer.');
      return response.json();
    }).then(function (cartState) {
      cartState.id = getAddedItemId(data);
      return renderCartDrawerState(cartState, true);
    }).catch(function () {
      return false;
    });
  }

  function refreshAndOpenCartDrawer(data) {
    refreshCartDrawer(data).then(function (refreshed) {
      var drawer = getCartDrawer();

      if (!refreshed || !drawer || !drawer.classList.contains('active')) {
        openCartDrawer();
      }
    });
  }

  function installCartAddDrawerHook() {
    if (!window.fetch || window.__oyxCartFlowFetchWrapped) return;

    var nativeFetch = window.fetch;
    window.__oyxCartFlowFetchWrapped = true;

    window.fetch = function () {
      var input = arguments[0];
      var shouldOpenDrawer = isCartAddRequest(input) && !window.__oyxBuyNowActive;
      var shouldRefreshChangedCart = isCartChangeRequest(input);

      return nativeFetch.apply(this, arguments).then(function (response) {
        if ((shouldOpenDrawer || shouldRefreshChangedCart) && response && response.ok) {
          response.clone().json().then(function (data) {
            if (!data || data.status || data.errors) return;

            if (shouldOpenDrawer) {
              window.setTimeout(function () {
                refreshAndOpenCartDrawer(data);
              }, 120);
            }

            if (shouldRefreshChangedCart) {
              window.setTimeout(function () {
                var drawer = getCartDrawer();
                var shouldOpen = !!(drawer && drawer.classList.contains('active'));

                if (shouldOpen && !renderCartDrawerState(data, true)) {
                  refreshAndOpenCartDrawer(data);
                }
              }, 120);
            }
          }).catch(function () {});
        }

        return response;
      });
    };
  }

  function groupVariantIds(ids, sharedOptions) {
    var grouped = {};

    ids.forEach(function (id) {
      if (!id) return;
      var key = String(id);
      grouped[key] = (grouped[key] || 0) + 1;
    });

    return Object.keys(grouped).map(function (id) {
      var item = {
        id: Number(id),
        quantity: grouped[id]
      };

      if (sharedOptions && sharedOptions.properties) item.properties = sharedOptions.properties;
      if (sharedOptions && sharedOptions.selling_plan) item.selling_plan = sharedOptions.selling_plan;

      return item;
    });
  }

  function getSelectedQuantity(form) {
    var checkedQuantity = form.querySelector('input[name="quantity"]:checked');
    var inputQuantity = form.querySelector('input[name="quantity"], select[name="quantity"]');
    var value = checkedQuantity ? checkedQuantity.value : inputQuantity ? inputQuantity.value : 1;
    var quantity = parseInt(value, 10);

    return quantity > 0 ? quantity : 1;
  }

  function getVariantId(form) {
    var variantInput = form.querySelector('.product-variant-id') || form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : '';
  }

  function getSharedOptions(form) {
    var formData = new FormData(form);
    var properties = {};
    var hasProperties = false;
    var sellingPlan = '';

    formData.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0) {
        var propertyName = key.replace(/^properties\[/, '').replace(/\]$/, '');
        if (propertyName && value !== '') {
          properties[propertyName] = value;
          hasProperties = true;
        }
      }

      if (key === 'selling_plan' && value !== '') {
        sellingPlan = value;
      }
    });

    return {
      properties: hasProperties ? properties : null,
      selling_plan: sellingPlan || null
    };
  }

  function buildBuyNowItems(productForm, form) {
    var sharedOptions = getSharedOptions(form);
    var sectionId = productForm && productForm.dataset ? productForm.dataset.section : '';
    var quantityBreaks = sectionId ? document.getElementById('quantity-breaks-' + sectionId) : null;

    if (quantityBreaks) {
      var checkedBreak = quantityBreaks.querySelector('input[name="quantity"]:checked');
      var breakQuantity = checkedBreak ? parseInt(checkedBreak.value, 10) : parseInt(quantityBreaks.selectedQuantity, 10);
      var variantIds = Array.isArray(quantityBreaks.formVariants) ? quantityBreaks.formVariants.slice() : [];
      var fallbackVariantId = getVariantId(form);

      if (!variantIds.length && fallbackVariantId) {
        breakQuantity = breakQuantity > 0 ? breakQuantity : 1;
        variantIds = Array.from({ length: breakQuantity }, function () {
          return fallbackVariantId;
        });
      }

      return groupVariantIds(variantIds, sharedOptions);
    }

    var variantId = getVariantId(form);
    if (!variantId) return [];

    return [{
      id: Number(variantId),
      quantity: getSelectedQuantity(form),
      properties: sharedOptions.properties || undefined,
      selling_plan: sharedOptions.selling_plan || undefined
    }];
  }

  function showProductError(productForm, message) {
    var wrapper = productForm ? productForm.querySelector('.product-form__error-message-wrapper') : null;
    var messageNode = productForm ? productForm.querySelector('.product-form__error-message') : null;

    if (messageNode) messageNode.textContent = message;
    if (wrapper) wrapper.hidden = false;
  }

  function clearProductError(productForm) {
    var wrapper = productForm ? productForm.querySelector('.product-form__error-message-wrapper') : null;
    var messageNode = productForm ? productForm.querySelector('.product-form__error-message') : null;

    if (messageNode) messageNode.textContent = '';
    if (wrapper) wrapper.hidden = true;
  }

  function setBuyNowLoading(button, isLoading) {
    button.disabled = isLoading;
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
    button.classList.toggle('loading', isLoading);
  }

  function handleBuyNow(button) {
    var productForm = button.closest('product-form');
    var form = productForm ? productForm.querySelector('form[data-type="add-to-cart-form"]') : null;

    if (!productForm || !form) return;

    var items = buildBuyNowItems(productForm, form);
    if (!items.length) {
      showProductError(productForm, 'Please choose a product option before checkout.');
      return;
    }

    clearProductError(productForm);
    setBuyNowLoading(button, true);
    window.__oyxBuyNowActive = true;

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status || data.errors) {
          throw new Error(data.description || data.message || 'Could not add this item to cart.');
        }
        window.location.href = checkoutUrl();
      });
    }).catch(function (error) {
      window.__oyxBuyNowActive = false;
      setBuyNowLoading(button, false);
      showProductError(productForm, error.message || 'Could not add this item to cart.');
    });
  }

  installCartAddDrawerHook();

  window.oyxHeaderCartClick = function (event, trigger) {
    if (!getCartDrawer()) return true;

    event.preventDefault();
    openCartDrawer(trigger);
    return false;
  };

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var cartTrigger = getCartTrigger(event.target);
    if (cartTrigger && getCartDrawer()) {
      event.preventDefault();
      openCartDrawer(cartTrigger);
      return;
    }

    var buyNowButton = event.target.closest('.oyx-buy-now-button');
    if (buyNowButton) {
      event.preventDefault();
      handleBuyNow(buyNowButton);
    }
  }, true);

  window.OYXCartFlow = {
    openCartDrawer: openCartDrawer
  };
})();
